import React from "react";

//component
import DragAndDropControls from "./DragAndDropControls";

//interfaces
import { IconLibrary } from "../../../../../interfaces/icon/IconLibrary";
import { IUseDragAndDropControlsProps } from "../../../../../interfaces/tables/ISimpleTable";


export const useDragAndDropControls = ({
    index,
    rowContentLength,
    paginationInformation,
    isPaginated,
    handleButtonMove,
}: IUseDragAndDropControlsProps) => {

    if (!isPaginated) {
        const totalItems = paginationInformation?.totalItems ?? 0;
        return [
            index !== 0 && { content: <DragAndDropControls iconName={IconLibrary.ORDER_TOP} text="Send to top" />, onClick: () => handleButtonMove(index, 0) },
            index !== 0 && { content: <DragAndDropControls iconName={IconLibrary.ORDER_UP} text="Move up" />, onClick: () => handleButtonMove(index, index - 1) },
            index !== totalItems - 1 && { content: <DragAndDropControls iconName={IconLibrary.ORDER_DOWN} text="Move down" />, onClick: () => handleButtonMove(index, index + 1) },
            index !== totalItems - 1 && { content: <DragAndDropControls iconName={IconLibrary.ORDER_BOTTOM} text="Send to bottom" />, onClick: () => handleButtonMove(index, totalItems) },
        ].filter(Boolean);
    }

    // Paginated version
    const currentPage = paginationInformation?.currentPage ?? 1;
    const totalPages = paginationInformation?.totalPages ?? 1;
    const totalItems = paginationInformation?.totalItems ?? 0;
    const resultsPerPage = paginationInformation?.resultsPerPage ?? 0;

    const isNotPageOne = currentPage > 1;
    const isNotLastPage = currentPage < totalPages;

    const previousIndex = index - 1;
    const nextIndex = index + 1;
    const lastIndex = totalItems;
    const isFirstItemButNotPageOne = index === 0 && isNotPageOne;

    const paginationPreviousIndex = isNotPageOne ? ((currentPage - 1) * resultsPerPage + previousIndex) : previousIndex;
    const paginationNextIndex = isNotPageOne ? ((currentPage - 1) * resultsPerPage + nextIndex) : nextIndex;
    const moveToNextPageIndex = currentPage * resultsPerPage;
    const moveToPreviousPageIndex = (currentPage - 2) * resultsPerPage;

    return [
        index !== 0 || isFirstItemButNotPageOne ? { content: <DragAndDropControls iconName={IconLibrary.ORDER_TOP} text="Send to top" />, onClick: () => handleButtonMove(index, 0, isNotPageOne) } : undefined,
        index !== 0 || isFirstItemButNotPageOne ? { content: <DragAndDropControls iconName={IconLibrary.ORDER_UP} text="Move up" />, onClick: () => handleButtonMove(index, paginationPreviousIndex, isFirstItemButNotPageOne) } : undefined,
        index !== rowContentLength - 1 ? { content: <DragAndDropControls iconName={IconLibrary.ORDER_DOWN} text="Move down" />, onClick: () => handleButtonMove(index, paginationNextIndex, false) } : undefined,
        index !== rowContentLength - 1 ? { content: <DragAndDropControls iconName={IconLibrary.ORDER_BOTTOM} text="Send to bottom" />, onClick: () => handleButtonMove(index, lastIndex, isNotLastPage) } : undefined,
        isNotPageOne ? { content: <DragAndDropControls iconName={IconLibrary.ORDER_UP} text="Move to previous page" />, onClick: () => handleButtonMove(index, moveToPreviousPageIndex, true) } : undefined,
        totalPages > 1 && isNotLastPage ? { content: <DragAndDropControls iconName={IconLibrary.ORDER_DOWN} text="Move to next page" />, onClick: () => handleButtonMove(index, moveToNextPageIndex, true) } : undefined,
    ].filter(Boolean);
};

